/**
 * .form-reset
 * Register a trigger for the reset buttons
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


$(function()
{
    "use strict";

    // Locate the form
    var formReset = function(){
        $(':input').not(':button, :submit, :reset, :hidden, :checkbox, :radio').val('');

        $(':checkbox, :radio').prop('checked', false);
    }
    // Bind the click
    $('input[type=reset]').bind('click', formReset);
});



